exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-content-row[data-v-94a8cb32] {\n  margin-top: 10vh;\n}\n.welcome-card-container[data-v-94a8cb32] {\n  background-color: white;\n  max-width: 600px;\n  text-align: center;\n  margin: auto;\n  padding-top: 48px;\n  padding-bottom: 38px;\n  padding-right: 30px;\n  padding-left: 30px;\n}\n.privacy-policy[data-v-94a8cb32] {\n  text-align: right;\n}\n.privacy-policy a[data-v-94a8cb32] {\n    color: white;\n    display: block;\n}\n.privacy-policy--extended[data-v-94a8cb32] {\n  position: absolute;\n  right: 15px;\n  bottom: 30px;\n}\n", ""]);

// exports
